import { render } from "./meusingressos.vue?vue&type=template&id=77b18708&scoped=true"
import script from "./meusingressos.vue?vue&type=script&lang=js"
export * from "./meusingressos.vue?vue&type=script&lang=js"

import "./meusingressos.vue?vue&type=style&index=0&id=77b18708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b18708"]])

export default __exports__